// @flow

import moment from 'moment';

import AbstractOrderModeSetting from './AbstractOrderModeSetting';

export default class OnSiteOrderSettings extends AbstractOrderModeSetting {

  /**
   * true if the on-site order mode is enabled.
   *
   * @type Boolean
   */
	enabled: boolean = false;

  /**
   * true if the on-site order mode is enabled for the bar.
   *
   * @type Boolean
   */
	orderAtBarAvailable: boolean = false;

  preOrderAvailable: boolean = false;
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/order/OnSiteOrderSettings.js